import React, { useContext } from "react";
import Bread from "../../common/Bread";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { Grid } from "@mui/material";
import TimeAgo from "../../common/TimeAgo";
import { Link } from "react-router-dom";
import "./career.scss";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";

const Career = () => {
  const lang = useContext(LangContext);
  const nep = lang.state.np; // true if Nepali is active

  const breadcrumList = {
    image: "",
    title: nep ? "क्यारियर" : "Career",
    l1: nep ? "होम" : "Home",
    l2: nep ? "क्यारियर" : "Career",
    l3: "",
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["careerData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/career/all`)
        .then((res) => res.data),
  });

  if (isFetching || isLoading) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // pick language-specific data
  const careerItems = nep ? data.items.np : data.items.en;

  return (
    <Bread data={breadcrumList}>
      {careerItems.length > 0 ? (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {careerItems.map((item, index) => (
            <Grid item xs={12} sm={4} md={4} key={index}>
              <div className="box-item-news">
                <div className="img-news">
                  <Link to={`/career/${item.id}`}>
                    <img src={item.DocPath} alt={item.Title} />
                  </Link>
                </div>
                <div className="content-news">
                  <TimeAgo timestamp={item.created_on} />
                  <h3 style={{ margin: 0 }}>
                    <Link to={`/career/${item.id}`}>
                      {item.Title.substring(0, 30)}
                    </Link>
                  </h3>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <h2 style={{ color: "#0f2137" }}>
          {nep
            ? "हाल कुनै पदहरु उपलब्ध छैनन्।"
            : "No positions available at the moment."}
        </h2>
      )}
    </Bread>
  );
};

export default Career;
